import { useEffect, useRef } from "react";
import { embedUrl } from "../../lib/video.js";
import { track } from "../../lib/analytics.js";

/** Renders build-time markdown HTML. One delegated click handler upgrades video facades. */
export default function Prose({ html, className = "" }) {
  const ref = useRef(null);
  useEffect(() => {
    const root = ref.current;
    if (!root) return undefined;
    const onClick = (event) => {
      const play = event.target.closest(".video-embed__play");
      if (play && root.contains(play)) {
        const box = play.closest(".video-embed");
        const { provider, id, title } = box.dataset;
        const iframe = document.createElement("iframe");
        iframe.src = embedUrl({ provider, id });
        iframe.title = title || "Video";
        iframe.allow = "autoplay; fullscreen; picture-in-picture";
        iframe.allowFullscreen = true;
        box.replaceChildren(iframe);
        box.classList.add("video-embed--playing");
        track("video_play", { video_title: title });
        return;
      }
      const pdf = event.target.closest(".pdf-link a");
      if (pdf && root.contains(pdf)) track("pdf_download", { file: pdf.getAttribute("href") });
    };
    root.addEventListener("click", onClick);
    return () => root.removeEventListener("click", onClick);
  }, [html]);
  return (
    <div
      ref={ref}
      className={`prose ${className}`.trim()}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
